import InvoiceList from '../components/invoice/List.vue';
import InvoiceCreate from '../components/invoice/Create.vue';
import InvoiceUpdate from '../components/invoice/Update.vue';
import InvoiceShow from '../components/invoice/Show.vue';

export default [
  { name: 'InvoiceList', path: '/invoice', component: InvoiceList },
  { name: 'InvoiceCreate', path: '/invoice/create', component: InvoiceCreate },
  { name: 'InvoiceUpdate', path: "/invoice/edit/:id", component: InvoiceUpdate },
  { name: 'InvoiceShow', path: "/invoice/show/:id", component: InvoiceShow  },
];



// WEBPACK FOOTER //
// ./src/routes/invoice.js